// extracted by mini-css-extract-plugin
module.exports = {"addToListButton":"_3JAUafzC","centerAlignTooltip":"_52utQQze"};